import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LocalCacheStorageService {

    protected elements: Object = {};

    constructor() { }

    setElement(key: string, value: any): void {
        this.elements[key] = value;
    }

    getElementByKey(key: string): any {
        return Observable.of(this.elements[key]);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/services/local-cache-storage.service.ts